import { Box, Typography } from '@mui/material';

interface Props {
    message: string;
}

export default function ProspectDetailsEmptyPage({ message }: Props) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 320,
                p: 3,
            }}
        >
            <Typography variant="body1" color="text.secondary" textAlign="center">
                {message}
            </Typography>
        </Box>
    );
}
